module.exports = __webpack_public_path__ + "img/ecology_card3.9b6b23d3.png";